export const SCALE = 2.2;//3.5;
export const WINDOWS_ENABLED = true;
export const PATIO_DOORS_ENABLED = true;
export const PLEATED_SCREENS_ENABLED = true;

// PDF generation pipeline switch.
//   true  -> server-side Playwright pipeline (doorapi /pdf/render).
//            Vector text, small files, immune to App.js DPI transform.
//            Requires doorapi built with the Chromium runtime libs.
//   false -> legacy client-side html2canvas + jsPDF (bigger raster PDFs).
// All PDF call sites read this flag and branch internally (Email attach,
// Packages/Promo-Financing dialog "PDF" button, per-window toolbar PDF,
// etc.) so the whole app flips pipelines from one place.
export const USE_PDF_SERVER = true;
/* Drawing */
export const FRAME_WIDTH = 8;
export const INITX = 60;
export const INITY = 60;
export const GAP   = 2;
export const CANVASW = 650;
export const CANVASH = 600;
export const DIMENTION_FONT_SIZE = 11;

// Moved to DB (crm_settings table) — managed via CRM Admin UI
// export const CRM_DEFINED = true;
// export const SIMPLE_CRM_ENABLED = true; // Enable built-in Simple CRM (alternative to Zoho)
// export const SIMPLE_CRM_QUOTE_MANAGER_ONLY = true;
// export const SIMPLE_CRM_COMMON_CUSTOMERS = false;
export const DRAWING_URL = `${window.location.origin}/windows/wint/w1`;

export const DEFAULT_SHAPE = "Rectangle";
export const USE_SHAPES = true;
export const USE_SHAPES_TOP = true;
export const SHAPES_VALIDATION_ACTIVE = true;
export const SHAPES_TOP_VALIDATION_ACTIVE = true;

export const ENABLE_FLOATING_NAV_MENU = true;
export const ENABLE_FLOATING_TOOLBAR_MENU = true;

export const WATERMARK_NAME = "Demo Windows/Doors Quotation Platform"

// Pricing debugging - set to false to hide DB Price and Match columns
export const SHOW_DB_PRICE_AND_MATCH = false; //debug mode
export const PRICES_FROM_DB = true //if false then prices come from JS: w16_priceRules.js
//this one above should work when SHOW_DB_PRICE_AND_MATCH = false

// ALLOW_TO_SEE_PRICING_REFERENCE — moved to AvailableFeature table (DB-driven, per-role)




